export default __webpack_public_path__ + "static/media/loader.6065c876.svg";